import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { FleetQueryService } from '../../services/fleet-query.service';
import { NspUpgradeService } from '../../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';

@Component({
    selector: 'fleet-embed',
    template: require('./fleet-embed.html'),
    styles: [require('./fleet-embed.scss')]
})

export class FleetEmbedComponent implements OnInit {

    private isSystemAdmin: boolean = false;
    private cmpType: string = '';
    private fleetEnabled:boolean = false;
    constructor(public nspUpgradeSvc: NspUpgradeService, private fleetQueryService: FleetQueryService,
                private authService: AuthService) {}

    public ngOnInit() {
        const me = this;
        this.nspUpgradeSvc.queryHcmInstances(
            () => {
                setTimeout(() => {
                    const localEndpoint = this.authService.getLocalHcmEndpoint();
                    this.fleetQueryService.getFleetAppliances(localEndpoint.resourceId).subscribe( (result:any) => {
                        if(result.fleet.appliances.length !== 0) {
                            this.fleetEnabled = true;
                        }
                    });
                }, 10);
            },
            null);

    }
}



// WEBPACK FOOTER //
// ./src/app/components/fleet/fleet-embed.ts